// extracted by mini-css-extract-plugin
export default {"tabs__tab-bar":"zlXHS"};